module.exports = __webpack_public_path__ + "img/chart-flowers-2-1x.a1dfc4b1.png";